import React, { useState, useEffect } from "react";
import {
    Box,
    Grid,
    TextField,
    MenuItem,
    Button,
    CircularProgress,
    Typography,
} from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import configServ from "../../services/config";
import toast from "react-hot-toast";

const BasicDetailsForm = ({ employeeId, companyId }) => {
    // 1. STATE FOR FORM FIELDS (MATCHING YOUR SQL SCHEMA)
    const [formData, setFormData] = useState({
        // first_name: "",
        // last_name: "",
        // email: "",
        // phone_number: "",
        father_name: "",
        mother_name: "",
        spouse_name: "",
        blood_group: "",
        marital_status: "single", // Default ENUM value
        nationality: "",
        religion: "",
        category: "",
        no_of_son: 0,
        no_of_daughters: 0,
        emergency_contact_number: "",
        permanent_address: "",
        aadhar_number: "",
        gender:"male"
    });

    const [loading, setLoading] = useState(false);
    const [submitLoading, setSubmitLoading] = useState(false);

    // 2. FETCH EXISTING USER DATA (FOR UPDATE MODE)
    useEffect(() => {
        const fetchBasicDetails = async () => {
            if (!employeeId) return; // Agar employeeId nahi hai matlab 'Create Mode' hai

            try {
                setLoading(true);
                // Apni fetch API route ko yaha configure karein
                const response = await configServ.getPersonalDetails({ employee_id: employeeId });

                if (response.status && response.data) {
                    // Backend data ko state ke sath sync karein
                    setFormData({
                        // first_name: response.data.first_name || "",
                        // last_name: response.data.last_name || "",
                        // email: response.data.email || "",
                        // phone_number: response.data.phone_number || "",
                        father_name: response.data.father_name || "",
                        mother_name: response.data.mother_name || "",
                        spouse_name: response.data.spouse_name || "",
                        blood_group: response.data.blood_group || "",
                        marital_status: response.data.marital_status || "single",
                        nationality: response.data.nationality || "",
                        religion: response.data.religion || "",
                        category: response.data.category || "",
                        no_of_son: response.data.no_of_son || 0,
                        no_of_daughters: response.data.no_of_daughters || 0,
                        emergency_contact_number: response.data.emergency_contact_number || "",
                        permanent_address: response.data.permanent_address || "",
                        aadhar_number: response.data.aadhar_number || "",
                        gender: response.data.gender || "male",
                    });
                }
            } catch (error) {
                console.error("Error fetching basic details:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchBasicDetails();
    }, [employeeId]);

    // 3. HANDLE INPUT CHANGES
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    // 4. SUBMIT/SAVE DATA (CREATE OR UPDATE API)
    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            setSubmitLoading(true);

            // Agar single hai toh conditional fields ko server par bhejne se pehle reset kar sakte hain
            const payload = {
                ...formData,
                employee_id: employeeId,
                company_id: companyId,
            };

            if (payload.marital_status === "single") {
                payload.spouse_name = "";
                payload.no_of_son = 0;
                payload.no_of_daughters = 0;
            }


            const result = await configServ.savePersonalDetails(payload);


            if (result.status) {
                toast.success("Information saved successfully!");
            } else {
                toast.error(result.message || "Something went wrong");
            }
        } catch (error) {
            console.error("Error saving data:", error);
            toast.error("Failed to save record.");
        } finally {
            setSubmitLoading(false);
        }
    };

    if (loading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="250px">
                <CircularProgress size={40} />
            </Box>
        );
    }

    return (
        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
            <Grid container spacing={2.5}>
                {/* Standard User Info Row */}
                {/* <Grid item xs={12} sm={6}>
          <TextField fullWidth name="first_name" value={formData.first_name} onChange={handleChange} label="First Name" variant="outlined" />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField fullWidth name="last_name" value={formData.last_name} onChange={handleChange} label="Last Name" variant="outlined" />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField fullWidth name="email" type="email" value={formData.email} onChange={handleChange} label="Email Address" variant="outlined" />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField fullWidth name="phone_number" value={formData.phone_number} onChange={handleChange} label="Phone Number" variant="outlined" />
        </Grid> */}

                {/* Parents Inputs */}
                <Grid item xs={12} sm={6}>
                    <TextField fullWidth name="father_name" value={formData.father_name} onChange={handleChange} label="Father's Name" variant="outlined" />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField fullWidth name="mother_name" value={formData.mother_name} onChange={handleChange} label="Mother's Name" variant="outlined" />
                </Grid>

                {/* Demographics Row */}
                <Grid item xs={12} sm={4}>
                    <TextField fullWidth name="blood_group" value={formData.blood_group} onChange={handleChange} label="Blood Group" placeholder="e.g. O+, A+" variant="outlined" />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <TextField fullWidth name="nationality" value={formData.nationality} onChange={handleChange} label="Nationality" variant="outlined" />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <TextField fullWidth name="religion" value={formData.religion} onChange={handleChange} label="Religion" variant="outlined" />
                </Grid>

                {/* Category & Emergency Contact */}
                <Grid item xs={12} sm={4}>
                    <TextField fullWidth name="category" value={formData.category} onChange={handleChange} label="Category" placeholder="General, OBC, SC/ST" variant="outlined" />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <TextField fullWidth name="emergency_contact_number" value={formData.emergency_contact_number} onChange={handleChange} label="Emergency Contact" variant="outlined" />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <TextField fullWidth name="aadhar_number" value={formData.aadhar_number} onChange={handleChange} label="Aadhar Number" variant="outlined" />
                </Grid>

                {/* gender */}

                <Grid item xs={12} sm={4}>
                    <TextField
                        select
                        fullWidth
                        name="gender"
                        label="Gender"
                        value={formData.gender}
                        onChange={handleChange}
                        variant="outlined"
                    >
                        <MenuItem value="male">Male</MenuItem>
                        <MenuItem value="female">Female</MenuItem>
                        <MenuItem value="other">Other</MenuItem>
                    </TextField>
                </Grid>

                {/* Marital Status (Dropdown Selector) */}
                <Grid item xs={12} sm={4}>
                    <TextField
                        select
                        fullWidth
                        name="marital_status"
                        label="Marital Status"
                        value={formData.marital_status}
                        onChange={handleChange}
                        variant="outlined"
                    >
                        <MenuItem value="single">Single</MenuItem>
                        <MenuItem value="married">Married</MenuItem>
                        <MenuItem value="divorced">Divorced</MenuItem>
                        <MenuItem value="widowed">Widowed</MenuItem>
                    </TextField>
                </Grid>

                {/* ==========================================
            CONDITIONAL RENDERING FIELDS 
            (Hidden when marital_status is 'single')
           ========================================== */}
                {formData.marital_status !== "single" && (
                    <>
                        <Grid item xs={12} sm={4}>
                            <TextField fullWidth name="spouse_name" value={formData.spouse_name} onChange={handleChange} label="Spouse Name" variant="outlined" />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <TextField fullWidth type="number" name="no_of_son" value={formData.no_of_son} onChange={handleChange} label="Number of Sons" variant="outlined" />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <TextField fullWidth type="number" name="no_of_daughters" value={formData.no_of_daughters} onChange={handleChange} label="Number of Daughters" variant="outlined" />
                        </Grid>
                    </>
                )}

                {/* Address */}
                {/* <Grid item xs={12}>
                    <TextField fullWidth multiline rows={3} name="permanent_address" value={formData.permanent_address} onChange={handleChange} label="Permanent Address" variant="outlined" />
                </Grid> */}
            </Grid>
            

            {/* FORM ACTION CONTROL */}
            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3 }}>
                <Button
                    type="submit"
                    variant="contained"
                    disabled={submitLoading}
                    startIcon={submitLoading ? <CircularProgress size={20} color="inherit" /> : <SaveIcon />}
                    sx={{
                        borderRadius: "10px",
                        px: 4,
                        py: 1.2,
                        fontWeight: "600",
                        textTransform: "none",
                    }}
                >
                    {submitLoading ? "Saving..." : "Save Details"}
                </Button>
            </Box>
        </Box>
    );
};

export default BasicDetailsForm;